import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import BobPage from '../../../components/BobPage';
import BobLoadingMask from '../../../components/BobLoadingMask';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import * as BobActions from '../../../actions/bobActions';
import * as DashboardActions from '../../../actions/dashboardActions';
import classes from './CalculatedSensor.module.css';
import CalculatedSensorForm from './CalculatedSensorForm';
import { useHistory } from 'react-router-dom';
import BobModal from '../../../components/BobModal';
import { Mixpanel } from '../../../helpers/mixpanel';

const MIXPANEL_EVENT = 'Calculated Sensors';

const CalculatedSensor = ({
    activeNavClient,
    activeNavCompany,
    activeNavSite,
    history,
    activeFormula,
    activeTemplate,
    companies,
    currentUser,
    bobLoading,
    sensorHistory,
    ...props
}) => {
    const [confirmationOpen,setConfirmationOpen] = useState(false);
    const [tab,setTab] = useState('Formula');

    const history1 = useHistory();

    useEffect(() => {
        Mixpanel.track(MIXPANEL_EVENT, {
            company:  activeNavCompany.companyName,
            userName: `${currentUser.firstName} ${currentUser.lastName}`,
            email:    currentUser.email,
            client:   activeNavClient.name,
            site:     activeNavSite.name
        });
     
    }, []);

    const handleCancel = () => {
        let text = isFormulaChanged();
        if (text) {
            setConfirmationOpen(true);
        } else {
            if (history1.location.search && history1.location.state && history1.location.state.returnUrl) {
                window.location  = history1.location.state.returnUrl.pathname+history1.location.state.returnUrl.search;
            }
            else {  
                history.goBack();
            }
        }
    };

    const isFormulaChanged = ()=>{
        let ip = document.querySelector('#formula-editor');
        if (ip === null) {
            return false;
        }
        const template = getStringFromHTMLFormula();
        if (tab === 'Formula') {
            if (activeFormula && activeFormula.id) {
                return template !==  activeFormula.template ? true :false;
            }
            else if (template) {
                return true;
            }
            return false;
        }
        else {
            if (template && activeTemplate && activeTemplate.id) {
                return template.replace(/\s/g, '') !== activeTemplate.formulaCode.replace(/\s/g, '') ? true :false;
            }
            else if (template) {
                return true;
            }
            return false;
        }
    };




    const handleConfirmation = ()=>{
        setConfirmationOpen(false);
    };

    const submitFormula = ()=>{
        handleConfirmation();
        if (history1.location.search && history1.location.state && history1.location.state.returnUrl) {
            window.location  = history1.location.state.returnUrl.pathname+history1.location.state.returnUrl.search;
        }
        else {  
            history.goBack();
        }
    };

    const setSelectedTab = (tab) =>{
        setTab(tab);
    };

    const getStringFromHTMLFormula = ()=>{
        let text = '';
        let input = document.querySelector('#formula-editor');
        if (input) {
            for (let i=0; i<input.childNodes.length; i++) {
                if (input.childNodes[i].tagName && input.childNodes[i].tagName.toLowerCase() === 'input') {
                    text += input.childNodes[i].value;              
                }
                else {
                    text += input.childNodes[i].textContent;
                }
            }
            text = text.replace(/(\r\n|\n|\r)/gm, '').trim();
        }
        return text;
    };


    
    return (
        <BobPage>
            <div className={classes.SensorPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>

                <div className={classes.HeaderPanel}>                 
                    <span>
                        <span
                            className={classes.BackIcon}
                            aria-hidden="true"
                            role="button"
                            tabIndex={0}
                            onClick={() =>
                                handleCancel()
                            }
                        >
                            <i className="fas fa-chevron-left" />
                        </span>
                        Calculated Sensor
                    </span> 
                    
                </div>

                <div className={classes.FormPanel}>
                    <CalculatedSensorForm setSelectedTab={setSelectedTab} />          
                </div>
            </div>
            {
                bobLoading.includes('SensorCalculations')  ?
                    <BobLoadingMask />
                    :
                    null
            }

            {confirmationOpen?
                <BobModal
                    confirmText="Yes"
                    cancelText="No"
                    rootClass={'announcement-delete-modal formula-delete-modal'}
                    onCancel={handleConfirmation}
                    onClose={handleConfirmation}
                    onConfirm={submitFormula}
                    open={confirmationOpen}
                    title={'Formula Confirmation'}
                >
                    Your unsaved changes will be discarded. Are you sure you wish to continue?
                </BobModal>
                :''}
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:    state.bob.activeNavClient,
        activeNavCompany:   state.bob.activeNavCompany,
        activeNavSite:      state.bob.activeNavSite,
        allSensors:         state.bob.allSensors,
        allSensorsMeta:     state.bob.allSensorsMeta,
        bobLoading:         state.bob.bobLoading,
        sensorCalculations: state.dashboard.sensorCalculations,
        companies:          state.core.companies,
        currentUser:        state.currentUser,
        activeFormula:      state.dashboard.activeFormula,
        activeTemplate:     state.dashboard.activeTemplate
    };
};

const mapDispatchToProps = {
    ...BobActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CalculatedSensor));
